import React, { useCallback, useEffect, useState } from "react";
import {
  FiCalendar,
  FiExternalLink,
  FiMapPin,
  FiRefreshCw,
  FiUsers,
} from "react-icons/fi";
import { getRetreatEvent, getRetreatEventPageUrl } from "../api/hrmApi";
import ComponentLoader from "../components/ComponentLoader";

const EventsScreen = () => {
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const loadEvent = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const payload = await getRetreatEvent();
      const nextEvent = payload?.data?.event || payload?.event || null;
      setEvent((currentEvent) => nextEvent
        ? {
            ...nextEvent,
            submitted: Boolean(currentEvent?.submitted || nextEvent.submitted),
          }
        : currentEvent);
    } catch (loadError) {
      setError(loadError.message || "The event could not be loaded.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadEvent();
  }, [loadEvent]);

  return (
    <section className="new-hrm-screen new-hrm-events-screen">
      <header className="new-hrm-screen-heading">
        <div>
          <span className="new-hrm-page-kicker">COMPANY EVENTS</span>
          <h1>Events</h1>
          <p>Open active event pages, review the programme, and complete assigned actions.</p>
        </div>
      </header>

      {loading ? (
        <div className="new-hrm-events-loading">
          <ComponentLoader label="Loading events" />
        </div>
      ) : error ? (
        <div className="new-hrm-events-error" role="alert">
          <p>{error}</p>
          <button type="button" className="new-hrm-secondary-button" onClick={loadEvent}>
            <FiRefreshCw aria-hidden="true" />
            <span>Try again</span>
          </button>
        </div>
      ) : (
        <article className="new-hrm-event-card">
          <div className="new-hrm-event-card__marker" aria-hidden="true">
            <FiCalendar />
          </div>
          <div className="new-hrm-event-card__body">
            <div className="new-hrm-event-card__eyebrow">
              <span>Event page</span>
              <em>{event?.submitted ? "Submitted" : "New"}</em>
            </div>
            <h2>{event?.title || "Antrazal Annual Retreat 2026"}</h2>
            <p>Review the retreat programme and complete the appreciation vote using your signed-in HRM identity.</p>
            <dl className="new-hrm-event-card__facts">
              <div>
                <FiCalendar aria-hidden="true" />
                <dt>Date</dt>
                <dd>{event?.dateLabel || "21-23 August 2026"}</dd>
              </div>
              <div>
                <FiMapPin aria-hidden="true" />
                <dt>Venue</dt>
                <dd>{event?.venue || "Wild Rose Resort & Spa, Pushkar"}</dd>
              </div>
              <div>
                <FiUsers aria-hidden="true" />
                <dt>Ballot</dt>
                <dd>{event?.questionCount || 18} appreciation questions</dd>
              </div>
            </dl>
          </div>
          <div className="new-hrm-event-card__action">
            <a
              className="new-hrm-primary-button"
              href={getRetreatEventPageUrl()}
              target="_blank"
              rel="noopener noreferrer"
            >
              Open event page
              <FiExternalLink aria-hidden="true" />
            </a>
          </div>
        </article>
      )}
    </section>
  );
};

export default EventsScreen;
